import { useState, useEffect } from 'react'
import { getProvidentFundEmpAPI } from '../../../services/provident-fund'

function UseEmpPVD(orgId, searchs, keyUsername) {
  const [data, setData] = useState([])
  const param = {
    orgId,
    size: 20,
    searchs,
    page: 1,
    keyUsername
  }
  useEffect(() => {
    const getProvidentFundEmp = async () => {
      const result = await getProvidentFundEmpAPI(param)
      if (!result) return
      const newData = result.result.map((d, i) => {
        if (/^[a-zA-Z]+$/.test(searchs)) {
          return {
            value: d?.username,
            label: `${d?.code} ${d?.name_en} ${d?.surname_en}`,
            code: d?.code
          }
        } else {
          return {
            value: d?.username,
            label: `${d?.code} ${d?.name_th} ${d?.surname_th}`,
            code: d?.code
          }
        }
      })

      setData(newData)
    }
    if (orgId) {
      getProvidentFundEmp()
    }
  }, [keyUsername])
  return data
}

export default UseEmpPVD
